import React from 'react'

const IcUserX = ({ className, size = 20 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3376_60687)">
      <path d="M13.3335 17.5V15.8333C13.3335 14.9493 12.9823 14.1014 12.3572 13.4763C11.7321 12.8512 10.8842 12.5 10.0002 12.5H4.16683C3.28277 12.5 2.43493 12.8512 1.80981 13.4763C1.18469 14.1014 0.833496 14.9493 0.833496 15.8333V17.5M15.0002 6.66667L19.1668 10.8333M19.1668 6.66667L15.0002 10.8333M10.4168 5.83333C10.4168 7.67428 8.92444 9.16667 7.0835 9.16667C5.24255 9.16667 3.75016 7.67428 3.75016 5.83333C3.75016 3.99238 5.24255 2.5 7.0835 2.5C8.92444 2.5 10.4168 3.99238 10.4168 5.83333Z" stroke="#F04438" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3376_60687">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>

)

export default IcUserX
